export const UAE_PHONE_CODE = 'QA'
export const BUTTON_SEND_CALLBACK_TEST_ID = 'help-send-callback-button'
export const BASE_POPUP_TEST_ID = 'base-popup'
export const PHONE_INPUT_TEST_ID = 'phone-input'
